import { adgmProdConfig } from "./host_adgm_prod";
import { adgmBetaConfig } from "./host_adgm_beta";
// adgm暂时没有dev、pre的config，后续有的时候添加对应的配置文件即可
export const adgmConfig = {
  dev: adgmProdConfig,
  beta: adgmBetaConfig, // betaConfig
  pre: adgmProdConfig,
  prod: adgmProdConfig
};
